export default "__VITE_ASSET__BopKRGq7__"